import React, { Component } from 'react';
import '../myutils';
import {
    translate,
} from 'react-admin'; 
import CommunicationCallEnd from '@material-ui/icons/CallEnd';
import CommunicationCallReceived from '@material-ui/icons/CallReceived';
import AvVolumeMute from '@material-ui/icons/VolumeMute';
import CommunicationDialerSip from '@material-ui/icons/DialerSip';
import CommunicationCall from '@material-ui/icons/Call';
import MicOffIcon from '@material-ui/icons/MicOff';
import MicIcon from '@material-ui/icons/Mic';
import './dialpad.css';
import JsSIP from 'jssip'; 

var configuration = {}, session, callOptions, phone, remoteAudio = window.document.createElement('audio');
var ButtonArry =['1','2','3','4','5','6','7','8','9','*','0','#'];
var incomingCallAudio = new window.Audio('./swinging-617.mp3');
incomingCallAudio.loop = true;


export {configuration, session, remoteAudio, callOptions, phone, ButtonArry, incomingCallAudio};

class DialPad extends Component {
    
    constructor(){
        super()
        this.updateUI = this.updateUI.bind(this);
      }
    
    state = {
        showCallStatus: 'none',
        showCallButtons: 'block',
        showIncomingCall: 'none',
        showErrorMessage: 'none',
        showPhoneWrapper: 'block',
        showCallControl: 'block',
        callInfoText: '',
        callInfoNumber: '',
        fromField: sessionStorage.userDID,
        toField: '',
        DialNumbersVisible: false,
        MicIcon: false,
        MicOffIcon: false
      };
   
    
      updateUI = () => {
        if(configuration.uri && configuration.password){
            this.setState({showErrorMessage:'none'});
            this.setState({showPhoneWrapper:'block'});
            if(session){
                if(session.isInProgress()){
                    if(session.direction === 'incoming'){
                        this.setState({callInfoNumber:session.remote_identity.uri});
                        this.setState({showIncomingCall:'block'});
                        this.setState({showCallControl:'none'});
                    }
                    else{
                        this.setState({callInfoText:'Ringing...'});
                        this.setState({callInfoNumber:session.remote_identity.uri.user});
                        this.setState({showCallStatus:'block'});
                    }
                }
                else if(session.isEstablished()){
                    this.setState({showCallStatus:'block'});
                    this.setState({showIncomingCall:'none'});
                    this.setState({callInfoText:'In Call'});
                    this.setState({callInfoNumber:session.remote_identity.uri.user});
                    this.setState({showCallButtons:'block'});
                    incomingCallAudio.pause();
                }
                this.setState({showCallControl:'none'});
            }
            else{
                this.setState({showIncomingCall:'none'});
                this.setState({showCallControl:'block'});
                this.setState({showCallStatus:'none'});
                this.setState({showCallButtons:'none'});
                incomingCallAudio.pause();
            }
            //microphone mute icon
            if(session && session.isMuted().audio){
                this.setState({MicIcon: false, MicOffIcon: true})
            }else{
                this.setState({MicIcon: true, MicOffIcon: false})
            }
        }else{
            this.setState({showPhoneWrapper:'none'});
            this.setState({showErrorMessage:'block'});
        }
    }
    
    register = () => {
        var socket = new JsSIP.WebSocketInterface('wss://sip.yemot.co.il:8089/ws');
        // var incomingCallAudio = new window.Audio('https://code.bandwidth.com/media/incoming_alert.mp3');
        // incomingCallAudio.loop = true;
        var remoteAudio = new window.Audio();
        remoteAudio.autoplay = true;

        var reg = this.state.fromField;
        var password = this.state.passwordField;

        configuration = {
            sockets: [socket],
            uri: 'sip:' + reg + '@sip.yemot.co.il',
            password: password,
            hackIpInContact: true,
            rtcpMuxPolicy: 'negotiate'
        };


        remoteAudio.autoplay = true;

            callOptions = {
              mediaConstraints: {audio: true, video: false},
                eventHandlers    : {
                    'progress': function(e) {
                      console.log('call is in progress');
                    },
                    'failed': function(e) {
                      console.log('call failed with cause: '+ e.message.data);
                    },
                    'ended': function(e) {
                      console.log('call ended with cause: '+ e.data);//.cause);
                    },
                    'confirmed': function(e) {
                      console.log('call confirmed');
                    },
                  },
                    pcConfig: {rtcpMuxPolicy: 'negotiate'},
                    rtcOfferConstraints : {'offerToReceiveAudio' : true,
                                            OfferToReceiveVideo: false},
                    DtlsSrtpKeyAgreement: true,
            };
            
            if(configuration.uri && configuration.password){
                JsSIP.debug.enable('JsSIP:*'); // more detailed debug output
                phone = new JsSIP.UA(configuration);
                phone.on('registrationFailed', function(ev){
                    alert('Registering on SIP server failed with error: ' + ev.cause);
                  configuration.uri = null;
                  configuration.password = null;
                  this.updateUI();
                });
                
                var me = this;
                phone.on('newRTCSession',function(ev){
                    var newSession = ev.session;
                    if(session){ // hangup any existing call
                        session.terminate();
                    }
                    session = newSession;
                    var completeSession = function(){
                            session = null;
                          me.updateUI();
                    };
                    session.on('ended', completeSession);
                    session.on('failed', completeSession);
                    session.on('accepted', function() {
                        remoteAudio.src = window.URL.createObjectURL(
                          session.connection.getRemoteStreams()[0]
                        );
                        me.updateUI();
                    });
                    session.on('confirmed',function() {
                        me.updateUI();
                    });
                    session.on('addstream', function(e){
                      incomingCallAudio.pause();
                      remoteAudio.src = window.URL.createObjectURL(
                          session.connection.getRemoteStreams()[0]
                        );
                    });
                    if(session.direction === 'incoming'){
                        incomingCallAudio.play();
                        console.log('incoming--------------')
                    }
                    me.updateUI();
                });
                phone.start();
            }
            this.updateUI();      
    };

    handleToFieldChange = (e) => {
        this.setState({ toField: e.target.value });
     };

     handleFromFieldChange = (e) => {
        this.setState({ fromField: e.target.value });
     };

     handlePasswordFieldChange = (e) => {
        this.setState({ passwordField: e.target.value });
     };


    connectCall = () => {
        var dest = this.state.toField;
        session = phone.call(dest, callOptions);
        this.updateUI();
        this.setState({DialNumbersVisible: true})
    };
    
    answer = () =>{
        session.answer(callOptions);
        this.setState({DialNumbersVisible: true})
    }

    hangup = () =>{
        session.terminate();
        this.setState({DialNumbersVisible: false})
    }

    mute = () =>{
        console.log('MUTE CLICKED');
        if(session.isMuted().audio){
            session.unmute({audio: true});
        }else{
            session.mute({audio: true});
        }
        this.updateUI();
    }
    
    inCallButtons = (e) =>{
        var $target = (e.target);
        var value = $target.data('value');
        session.sendDTMF(value.toString());
    }
        
    handleKeyDown = (e) => {
            if (e.key === 'Enter') {
                this.connectCall();
            }
    }
        
    render() {
        return (
        <div>
            
            {/* {this.state.session} */}
            {/* {this.phone} */}
            <div id="errorMessage" style={{display: this.state.showErrorMessage}}>must set sip uri/password</div>
            <div id="phoneWrapper" style={{display: this.state.showPhoneWrapper}}>
                <div id="incomingCall" style={{display: this.state.showIncomingCall}}>
                    <div class="callInfo">
                        <h3>Incoming Call</h3>
                        <p id="incomingCallNumber">Unknown</p>
                    </div>
                    <div id="answer" onClick={this.answer}> <CommunicationCallReceived/></div>
                    <div id="reject" onClick={this.hangup}> <CommunicationCallEnd/></div>
                </div>
                <div id="callStatus" style={{display: this.state.showCallStatus}} >
                    <div class="callInfo">
                        <h3 id="callInfoText">{this.state.callInfoText}</h3>
                        <p id="callInfoNumber">{this.state.callInfoNumber}</p>
                    </div>
                    <div id="hangUp" onClick={this.hangup}><CommunicationCallEnd/></div>
                </div>
                {/* <!---------TO FIELD----------------------------------------------------> */}
                {/* <!---------DIALPAD----------------------------------------------------> */}
                <div id="inCallButtons" style={{display: this.state.showCallButtons}}>
                    { this.state.DialNumbersVisible ? <Dialnumbers MicIcon={this.state.MicIcon} MicOffIcon={this.state.MicOffIcon}/> : null }
                </div>
            {/* <!---------DIAL CONTROLS--------------------------------------------> */}
                <div id="callControl" style={{display: this.state.showCallControl}}>
                    <div id="to">
                    <input id="fromField" onChange={ this.handleFromFieldChange } placeholder={this.state.fromField}></input>
                    <input id="passwordField" onChange={ this.handlePasswordFieldChange } placeholder="Enter your password here"/>
                    </div>                
                    <div id="register" onClick={this.register} ><CommunicationDialerSip/></div>
                    <input id="toField" onKeyDown={this.handleKeyDown}  
                            onChange={ this.handleToFieldChange } placeholder="Enter number to dial here"/>
                    <div id="connectCall" onClick={this.connectCall}><CommunicationCall/></div>
                </div>
            </div>
        </div>
        );
    }
}

class Dialnumbers extends Component {
    render() {
        var divButtons = ButtonArry.map(item => <div class="dialpad-char" data-value={item} unselectable="on" onClick={this.inCallButtons}> {item} </div>)

        return (
            <div>
                <div id="dialPad">
                {divButtons}
                </div>
                <div id="mute" onClick={this.mute}>
                <div id="muteIcon">
                {(this.props.MicIcon)&&<MicIcon/>}    
                {(this.props.MicOffIcon)&&<MicOffIcon/>}    
                    <AvVolumeMute/>
                </div>
            </div>
            </div>
        )
    }
}

export default translate(DialPad);
